import type from './constants';

const initState = {
    searchParams: {},
    pagination: {},
    // 清除state
    clearState: true,
    // 使用state
    useState: false,
}

export default (state = initState, actions) => {
    switch(actions.type) {
        case type.SAVE_SEARCH_PARAMS:
            return {
                ...state,
                searchParams: {
                    ...actions.params
                }
            };
        case type.SAVE_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...actions.params
                }
            };
        case type.UPDATE_CLEAR_STATE:
            return {
                ...state,
                clearState: !state.clearState
            };
        case type.UPDATE_USE_STATE:
            return {
                ...state,
                useState: !state.useState
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/manHour/query/store/reducer.js